import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAsync, postAsync } from "src/api/Api";
import { store } from "src/redux/store";
import {  MOCK_FX_ELIGIBILITY_RESPONSE, MOCK_GET_STRINGS_RESPONSE, MOCK_PAUSED_ACTIVE_RECORDING_RESPONSE, MOCK_SEND_LEAD_OR_SMS_RESPONSE, MOCK_START_ONBOARDING_ENSURE_RESPONSE } from "src/utils/mockResponses";
import { CASE_DATA_REQUEST, CheckFxEligibilityResponse, PausedActiveRecordingRequest, PausedActiveRecordingResponse, SendLeadOrSmsResponse, StartOnboardingEnsureResponse, TranslationsResponse, UpdateOnboardingAnalytics } from "src/utils/types";

const isMockDataEnabled = () => store.getState().app.mockDataEnabled;

export const getStrings = createAsyncThunk(
  "appStore/getStrings",
  async (hideLoader?: boolean) => {
    const data = {
      url: "/qry/dictionary",
      hideLoader: hideLoader,
    };
    if (isMockDataEnabled()) {
      return MOCK_GET_STRINGS_RESPONSE as TranslationsResponse;
    }

    const response = await getAsync(data);
    // Merge mock data with server response
    const mergedResponse = {
      responseMessage: "",
      responseCode: "",
      responseData: {
        strings: {
          ...MOCK_GET_STRINGS_RESPONSE.responseData.strings,
          ...response["he-IL"],
        }
      }
    } as TranslationsResponse;
    
    return mergedResponse;
  }
);

export const getIframeUrl = createAsyncThunk(
  "appStore/getIframeUrl",
  async (body: any) => {
    const data = {
      url: "/cmd/credit-guard/get-iframe",
      body,
    };

    const response = await postAsync(data);

    return response;
  }
);
export const createCaseRequest = createAsyncThunk(
  "appStore/createCaseRequest",
  async (body: CASE_DATA_REQUEST) => {
    const data = {
      fullUrl:
        "https://prod-13.northeurope.logic.azure.com:443/workflows/04085ed134484bbfb5eaec50a61336ef/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=1Nc6x3Hwcnk4cOFcpq7jeVFIbKRCvXpbaWFH8Sneg8k",
      body,
    };

    const response = await postAsync(data);

    return response;
  }
);
export const checkFXEligibility = createAsyncThunk(
  "appStore/CheckFXEligibility",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_FX_ELIGIBILITY_RESPONSE as CheckFxEligibilityResponse;
    }
    const sessionId = store.getState().app.sessionId;
    const data = {
      url: "/qry/card/check-fx-eligibility",
      body: { ...body, sessionId },
    };
    const response = await postAsync(data);
    return response;
  }
);

export const inquireGCIframeResults = createAsyncThunk(
  "appStore/inquireGCIframeResults",
  async (body: any) => {
    const data = {
      url: "/cmd/credit-guard/get-iframe-result",
      body,
    };

    const response = await postAsync(data);

    return response;
  }
);

export const sendLeadOrSms = createAsyncThunk(
  "appStore/sendLeadOrSms",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_SEND_LEAD_OR_SMS_RESPONSE as SendLeadOrSmsResponse;
    }
    const data = {
      url: "/cmd/send-lead-or-sms",
      body,
    };

    const response = await postAsync(data);

    return response;
  }
);
export const updateOnboardingAnalytics = createAsyncThunk(
  "appStore/logPfsAnalyticsEvent",
  async (data: UpdateOnboardingAnalytics) => {
    const response = await postAsync({
      url: "/cmd/update-analytics",
      body: data,
    });
    return response;
  }
);
//
export const pausedActiveRecording = createAsyncThunk(
  "appStore/pausedActiveRecording",
  async (body: PausedActiveRecordingRequest) => {
    if (isMockDataEnabled()) {
      return MOCK_PAUSED_ACTIVE_RECORDING_RESPONSE as PausedActiveRecordingResponse;
    }
    const response = await postAsync({
      url: "/cmd/genesis-recording",
      body,
    });
    return response;
  }
);
export const startOnboardingEnsure = createAsyncThunk(
  "appStore/startOnboardingEnsure",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_START_ONBOARDING_ENSURE_RESPONSE as StartOnboardingEnsureResponse;
    }
    const response = await postAsync({
      url: "/cmd/start-onboarding-ensure",
      body,
    });
    return response;
  }
);
  